import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import SectorPerformanceChart from './SectorPerformanceChart';
import SectorPerformanceDay7Chart from './SectorPerformanceDay7Chart';
import SectorPerformanceDay30Chart from './SectorPerformanceDay30Chart';
import SectorPerformanceDay90Chart from './SectorPerformanceDay90Chart';
import SectorPerformanceDay180Chart from './SectorPerformanceDay180Chart';
import SectorPerformanceDay365Chart from './SectorPerformanceDay365Chart';

class GroupsWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>US Sectors Performance Chart</title>
          <link rel="canonical" href="https://www.vizfm.com/groups" />
          <meta name="description" content="US stock sector performance for Current day, a week, a month, 3 months, 6 months and 1 year " />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col><SectorPerformanceChart /></Col>
            <Col><SectorPerformanceDay7Chart /></Col>
            <Col><SectorPerformanceDay30Chart /></Col>
          </Row>
          <Row>
            <Col><SectorPerformanceDay90Chart /></Col>
            <Col><SectorPerformanceDay180Chart /></Col>
            <Col><SectorPerformanceDay365Chart /></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default GroupsWrap;
